import { render, staticRenderFns } from "./suggestionBox.vue?vue&type=template&id=83dccf20&scoped=true"
import script from "./suggestionBox.vue?vue&type=script&lang=js"
export * from "./suggestionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dccf20",
  null
  
)

export default component.exports